import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "3.1em",
  height: "3.1em",
  viewBox: "0 0 41 41"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"Group 5479\" transform=\"translate(-302.352 -10870.857)\"><rect data-name=\"Rectangle 3504\" width=\"40\" height=\"40\" rx=\"5\" transform=\"translate(302.352 10870.857)\"></rect><g data-name=\"Group 5478\"><path data-name=\"Path 8370\" d=\"M16515.314 12327.116v14.4\" transform=\"translate(-16192.963 -1443.46)\" style=\"fill:none;stroke:#000;stroke-linecap:round;stroke-width:2px;\"></path><path data-name=\"Path 8371\" d=\"M0 0v14.4\" transform=\"rotate(-90 5603.004 5287.854)\" style=\"fill:none;stroke:#000;stroke-linecap:round;stroke-width:2px;\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };